import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class RedirectionLinksService {

  static getRedirectionLink = (activeRole: string): string => {
    if(activeRole === 'MARKETING') {
      return 'marketing/customerQueries'
    } else if(activeRole === 'INSTITUTION') {
      return 'dashboard'
    } else if(activeRole === 'BD') {
      return 'bdFunnel/hospitalOnboarding'
    }
    else if(activeRole === 'HOSPITAL' || activeRole === 'SUB_HOSPITAL') {
      return 'myProfile'
    }
    //  else if(activeRole === 'SALES_SUPERVISOR') {
    //   return 'salesFunnel/enquiryList'
    else if(activeRole === 'SUPERADMIN') {
      return 'operations/loyaltyDashboard'
    } else if(activeRole === 'FINANCE_SUPERVISOR') {
      return 'finance/hospitalMasterData'
    } else if(activeRole === 'FINANCE') {
      return 'finance/loyaltyTransactions'
    } else if(activeRole === 'FINANCE_MANAGER') {
      return 'finance/loyaltyTransactions'
    // } else if(activeRole === 'BD') {
    //   return 'bdFunnel/hospitalOnboarding'
    // } else if(activeRole === 'INSTITUTION') {
    //   return 'dashboard'
    } else if(activeRole === 'OPS') {
      return 'operations/loyaltyDashboard'
    } else {
      return ''
    }
  }
}